
  let slideIndex = 1;
  showSlidesWed(slideIndex);
  
  function plusSlidesWed(n) {
    showSlidesWed(slideIndex += n);
  }
  
  function currentSlideWed(n) {
    showSlidesWed(slideIndex = n);
  }
  
  function showSlidesWed(n) {
    let i;
    let slidesWed = document.getElementsByClassName("mySlides");
    var rightBtn = document.getElementById("rightBtn");
    var leftBtn = document.getElementById("leftBtn");
    if (n > slidesWed.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slidesWed.length}
    for (i = 0; i < slidesWed.length; i++) {
      slidesWed[i].style.display = "none";  
    }
    slidesWed[slideIndex-1].style.display = "block";  

    if (n == 1) {
      leftBtn.disabled = true;
    }
    else {
      leftBtn.disabled = false;
    }
    if (n == 12) {
      rightBtn.disabled = true;
    }
    else {
      rightBtn.disabled = false;
    }
  }
